module.exports = __webpack_public_path__ + "static/media/Splash_BG@3x.51d9bdb2.jpg";